import { render, staticRenderFns } from "./yikuMain.vue?vue&type=template&id=eaf74d50&scoped=true&"
import script from "./yikuMain.vue?vue&type=script&lang=js&"
export * from "./yikuMain.vue?vue&type=script&lang=js&"
import style0 from "./yikuMain.vue?vue&type=style&index=0&id=eaf74d50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaf74d50",
  null
  
)

export default component.exports